module.exports = __webpack_public_path__ + "static/media/editor-icon-ordered-list.35874e04.svg";